import { render } from "./headerCommande.vue?vue&type=template&id=661fd0ca"
import script from "./headerCommande.vue?vue&type=script&lang=ts"
export * from "./headerCommande.vue?vue&type=script&lang=ts"
script.render = render

export default script